// src/layouts/AuthenticatedLayout.jsx
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import PlanNavbar from '../components/Navbar/PlanNavbar';
import { GetCurrentPlan } from '../services/MyProfileApi';
import { isPlanExpired } from '../utils/planUtils';
import LoadingScreen from '../components/common/LoadingScreen';
import useLoadingStore from '../store/useLoadingStore';

// export default function AuthenticatedLayout() {
//   const location = useLocation();
//   const { handleLogout } = useAuth();

//   useEffect(() => {
//     if (!location.pathname.includes('/login')) {
//       localStorage.setItem('lastVisitedRoute', location.pathname);
//     }
//   }, [location]);

//   return (
//     <div className="app">    
//       <PlanNavbar />  
//       <Navbar onLogout={handleLogout} />
//       <div className="side-bar-container">
//         <Sidebar />
//         <div className="main-content">
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// }

export default function AuthenticatedLayout() {
  const location = useLocation();
  const { handleLogout } = useAuth();

  const [planExpired, setPlanExpired] = useState(false);
  const isLoading = useLoadingStore((state) => state.loadingStates[location.pathname] || false);

  useEffect(() => {
    if (!location.pathname.includes("/login")) {
      localStorage.setItem("lastVisitedRoute", location.pathname);
    }
  }, [location]);

  useEffect(() => {
    checkPlanStatus();
  }, []);

  const checkPlanStatus = async () => {
    try {
      const res = await GetCurrentPlan();
      const plan = res?.data;

      if (isPlanExpired(plan?.end_date) || plan?.status !== "Active") {
        setPlanExpired(true);
      }
    } catch (err) {
      console.error("Plan check failed", err);
    }
  };
  // const checkPlanStatus = async () => {
  //   try {
  //     const res = await GetCurrentPlan();
  //     const plan = res?.data;
  
  //     //  FORCE POPUP FOR TESTING
  //     const FORCE_EXPIRED = true;
  
  //     if (
  //       FORCE_EXPIRED ||
  //       isPlanExpired(plan?.end_date) ||
  //       plan?.status !== "Active"
  //     ) {
  //       setPlanExpired(true);
  //     }
  //   } catch (err) {
  //     console.error("Plan check failed", err);
  //   }
  // };
  
  return (
    <>
      {/* POPUP */}
      {/* {planExpired && <PlanExpiredPopup onLogout={handleLogout} />} */}

      {/* BLUR WHEN EXPIRED */}
      {/* <div className={`app ${planExpired ? "blurred" : ""}`}> */}
      <div className="app">
        <PlanNavbar />
        <Navbar onLogout={handleLogout} />

        <div className="side-bar-container">
          <Sidebar />
          <div className="main-content" style={{ position: 'relative' }}>
            <LoadingScreen isOpen={isLoading} />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}